module.exports = __webpack_public_path__ + "static/media/AWT Intro_Outro_1622745258813.3ff50d73.docx";